import { createContext } from "react";

const CompanyContext = createContext({});

export default CompanyContext;

export const { Provider, Consumer } = CompanyContext;
